import { render } from "./TaskWorkList.vue?vue&type=template&id=0fa8228e"
import script from "./TaskWorkList.vue?vue&type=script&lang=js"
export * from "./TaskWorkList.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__